module.exports = __webpack_public_path__ + "img/horizontal_6_4_0.4ef9165e.png";